import { Block, Logo } from '@aloft/toolkit-sui';

import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { WebOnlyWrapper } from '../WebOnly/WebOnlyWrapper.tsx';

const Wrapper = (c: ReactNode) => (
  <Link to="/orders" id="home-link" data-testid="home-link">
    {c}
  </Link>
);

export const LogoHomeLink = () => (
  <Block marginTop="4px">
    <WebOnlyWrapper wrapper={Wrapper}>
      <Logo height={32} width={32} />
    </WebOnlyWrapper>
  </Block>
);
